import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubstationTemplateUICustomizationDto } from 'shared-lib';

@Component({
  selector: 'app-adv-map-preview-modal',
  standalone: false,
  templateUrl: './adv-map-preview-modal.html',
  styleUrl: './adv-map-preview-modal.scss',
})
export class AdvMapPreviewModal {
  @Input() substationTemplate?: SubstationTemplateUICustomizationDto | null = null;
  @Input() dynamicOptions: any[] = [];
  @Output() close = new EventEmitter<void>();
  
  closePopup() {
    this.close.emit();
  }
}
